import React from 'react';
import { cn } from '@/lib/utils';

interface ContentPreviewProps {
  content: string;
  className?: string;
  maxHeight?: string;
  showBorder?: boolean;
}

export const ContentPreview: React.FC<ContentPreviewProps> = ({
  content,
  className,
  maxHeight = '400px',
  showBorder = true
}) => {
  return (
    <div 
      className={cn(
        'prose prose-sm max-w-none overflow-auto p-4 bg-white',
        showBorder && 'border border-gray-200 rounded-lg',
        className
      )}
      style={{ maxHeight }}
    >
      <div 
        dangerouslySetInnerHTML={{ __html: content || '<p class="text-gray-400 italic">No content to preview</p>' }}
        className="prose-headings:font-semibold prose-h1:text-2xl prose-h2:text-xl prose-h3:text-lg prose-p:text-sm prose-li:text-sm prose-a:text-blue-600 prose-blockquote:border-l-blue-500 prose-blockquote:bg-blue-50 prose-img:rounded-lg prose-img:shadow-sm"
      />
      
      {/* Custom styles for content preview */}
      <style>{`
        .callout {
          background-color: #eff6ff !important;
          border-left: 4px solid #3b82f6 !important;
          padding: 1rem !important;
          margin: 1rem 0 !important;
          border-radius: 0.375rem !important;
        }
      `}</style>
    </div>
  );
};

export default ContentPreview;